/* import __COLOCATED_TEMPLATE__ from './power-select-multiple-extended.hbs.js'; */
import PowerSelectMultiple from 'ember-power-select/components/power-select-multiple';
export default class PowerSelectMultipleExtended extends PowerSelectMultiple {}